<div class="org-container">
  <div class="screen">
    <div class="screen__content">
      <div class="org-form">
        <h1 class="org__title">Select Your Organization</h1>
        <p class="org__subtitle">Enter your organization name to access your fitness box account.</p>

        <!-- Alert Messages -->
        <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
          {{ errorMessage }}
        </div>

        <div *ngIf="successMessage" class="alert alert-success" role="alert">
          {{ successMessage }}
        </div>

        <!-- Organization Form -->
        <form [formGroup]="orgForm" (ngSubmit)="onSubmitOrg()">
          <div class="org__field">
            <label for="orgSlug" class="org__label">Organization Name</label>
            <div class="org__input-wrapper">
              <i class="org__icon">🏢</i>
              <input
                type="text"
                id="orgSlug"
                formControlName="orgSlug"
                class="org__input"
                [class.is-invalid]="orgSlug?.invalid && (orgSlug?.dirty || orgSlug?.touched)"
                placeholder="e.g., my-fitness-box"
                (keyup.enter)="onSubmitOrg()"
              />
            </div>
            <!-- Validation Errors -->
            <div *ngIf="orgSlug?.invalid && (orgSlug?.dirty || orgSlug?.touched)" class="text-danger">
              <div *ngIf="orgSlug?.errors?.['required']">Organization name is required</div>
              <div *ngIf="orgSlug?.errors?.['minlength']">Minimum 3 characters required</div>
              <div *ngIf="orgSlug?.errors?.['pattern']">Only letters, numbers, and hyphens allowed</div>
            </div>
          </div>

          <button
            type="submit"
            class="button"
            [disabled]="orgForm.invalid || isLoading"
          >
            {{ isLoading ? 'Loading...' : 'Continue' }}
          </button>
        </form>

        <div class="org__footer">
          <p class="org__text">
            Don't have an organization yet?
            <a href="/signup">Create one now</a>
          </p>
        </div>
      </div>
    </div>
    <div class="screen__background">
      <div class="screen__background__shape"></div>
      <div class="screen__background__shape"></div>
      <div class="screen__background__shape"></div>
      <div class="screen__background__shape"></div>
    </div>
  </div>
</div>
